import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import classNames from 'classnames';
import { BasicTableView } from '@common/tables/basic-table-view';
import { InformationBanner } from '@common/information-banner/information-banner';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import styles from './provider-models-view.css';
export function ProviderModelsView(props) {
    const { errorMsg, infoMsg, withHeader, actions, models = [], columns, className } = props;
    const intColumns = useMemo(() => {
        return columns.map(column => {
            // fixme: Remove this when all tables will be reworked (IDES-5991)
            const { maxWidth } = column;
            if (maxWidth) {
                return {
                    ...column,
                    getValue: (model) => {
                        var _a, _b;
                        return (_jsx("div", { style: widthToCssProperties(maxWidth), className: styles.limitedWidthColumn, children: (_b = (_a = column.getValue) === null || _a === void 0 ? void 0 : _a.call(column, model, column)) !== null && _b !== void 0 ? _b : model[column.id] }));
                    }
                };
            }
            return column;
        });
    }, [columns]);
    return (_jsxs("section", { className: classNames(styles.wrapper, className), ...assignTestId('provider-models'), children: [withHeader && _jsx("header", { className: styles.header, children: "Models" }), infoMsg && (_jsx(InformationBanner, { className: styles.msg, variant: "danger", children: infoMsg })), errorMsg && (_jsx(InformationBanner, { className: styles.msg, variant: "danger", children: errorMsg })), !!models.length && (_jsx(BasicTableView, { ...assignTestId('models-table'), tableWrapperClassName: classNames(styles.table), columns: intColumns, data: models, selectable: false, size: "FULL" })), !!actions && _jsx("div", { className: styles.actions, children: actions })] }));
}
function widthToCssProperties(width) {
    return { '--column-width': `${width}px` };
}
